export default function HomeLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <main className="flex flex-col bg-neutral-50 overflow-x-hidden">
      {children}
    </main>
  );
}
